import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material/material.module';
import { GtTableComponent } from './gt-table/gt-table.component';
import { FilterNotInPipe } from './pipes/filter-not-in.pipe';
import { YesNoPipe } from './pipes/yes-no-pipe/yes-no.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { IsCheckedInComponent } from './ui/is-checked-in/is-checked-in.component';
import { TrueFalseComponent } from './ui/true-false/true-false.component';
import { EditRegistrationModalComponent } from './modals/edit-registration/edit-registration-modal.component';
import { EditTeamModalComponent } from './modals/edit-team-modal/edit-team-modal.component';
import { RoleGuardService } from './services/role-guard.service';
import { AlertModalComponent } from './modals/alert-modal/alert-modal.component';
import { MessageModalComponent } from './modals/message-modal/message-modal.component';
import { CommonModule } from '@angular/common';
import { YesNoComponent } from './ui/yes-no/yes-no.component';
import { GoogleSsoComponent } from './ui/google-sso/google-sso.component';
import { OutingOutingIterationSelectComponent } from './outing-outingiteration-select/outing-outingiteration-select.component';
import { TwilioVerificationModalComponent } from './modals/twilio-verification-modal/twilio-verification-modal.component';
import { EditOutingIterationDetailModalComponent } from './modals/edit-outing-iteration-detail-modal/edit-outing-iteration-detail-modal.component';
import { GroupByPipe } from './pipes/group-by-pipe/group-by.pipe';
import { SortByPipe } from './pipes/sort-by-pipe/sort-by.pipe';
import { SnackbarNotificationComponent } from './ui/snackbar-notification/snackbar-notification/snackbar-notification.component';
import { GtStripeService } from './services/gt-stripe.service';
import { SignalrService } from './services/signalr.service';
import { StripePaymentModalComponent } from './modals/stripe-payment-modal/stripe-payment-modal.component';
import { NgxStripeModule, StripeCardComponent, StripeElementsDirective, StripePaymentElementComponent } from 'ngx-stripe';
import { environment } from 'src/environments/environment';
import { StripeAddPaymentModalComponent } from './modals/stripe-add-payment-modal/stripe-add-payment-modal.component';
import { StripeEditPaymentModalComponent } from './modals/stripe-edit-payment-modal/stripe-edit-payment-modal.component';
import { StripeConnectExpressCreateModalComponent } from './modals/stripe-connect-express-create-modal/stripe-connect-express-create-modal.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MyAccountSkeletonComponent } from './ui/skeletons/my-account-skeleton/my-account-skeleton.component';
import { MyAccountSubscriptionsSkeletonComponent } from './ui/skeletons/my-account-subscriptions-skeleton/my-account-subscriptions-skeleton.component';
import { DashboardOrganizerSkeletonComponent } from './ui/skeletons/dashboard-organizer-skeleton/dashboard-organizer-skeleton.component';
import { StripeRegistrationPaymentModalComponent } from './modals/stripe-registration-payment-modal/stripe-registration-payment-modal.component';
import { StripeAddTerminalLocationModalComponent } from './modals/stripe-add-terminal-location-modal/stripe-add-terminal-location-modal.component';
import { StripeTerminalLocationsComponent } from '../account/my-account/my-account-player-payment/stripe-terminal-locations/stripe-terminal-locations.component';
import { StripeAddTerminalReaderModalComponent } from './modals/stripe-add-terminal-reader-modal/stripe-add-terminal-reader-modal.component';
import { StripeRefundModalComponent } from './modals/stripe-refund-modal/stripe-refund-modal.component';
import { AutocompleteComponent } from './ui/google-autocomplete/google-autocomplete.component';
import { AddCourseModalComponent } from './modals/add-course-modal/add-course-modal.component';
import { PostLoginLayoutSkeletonComponent } from './ui/skeletons/post-login-layout-skeleton/post-login-layout-skeleton.component';
import { CourseSelectCreateComponent } from './ui/course-select-create/course-select-create.component';
import { MyAccountPaymentMethodsComponent } from '../account/my-account/my-account-payment-methods/my-account-payment-methods.component';
import { PrimeNgModule } from '../widget/primeng/primeng.module';
import { SyncfusionModule } from '../simulator-booking/syncfusion.module';
import { SchedulerSkeletonComponent } from './ui/skeletons/scheduler-skeleton/scheduler-skeleton.component';
import { PaymentSuccessFailureComponent } from './ui/payment-success-failure/payment-success-failure.component';
import { MinutesToHoursPipe } from './pipes/minutes-to-hours.pipe';

@NgModule({
    declarations: [
        GtTableComponent,
        FilterNotInPipe,
        YesNoPipe,
        TruncatePipe,
        GroupByPipe,
        SortByPipe,
        MinutesToHoursPipe,
        IsCheckedInComponent,
        TrueFalseComponent,
        EditRegistrationModalComponent,
        EditTeamModalComponent,
        AlertModalComponent,
        MessageModalComponent,
        YesNoComponent,
        GoogleSsoComponent,
        OutingOutingIterationSelectComponent,
        TwilioVerificationModalComponent,
        EditOutingIterationDetailModalComponent,
        SnackbarNotificationComponent,
        StripePaymentModalComponent,
        StripeAddPaymentModalComponent,
        StripeEditPaymentModalComponent,
        StripeConnectExpressCreateModalComponent,
        MyAccountSkeletonComponent,
        MyAccountSubscriptionsSkeletonComponent,
        DashboardOrganizerSkeletonComponent,
        PostLoginLayoutSkeletonComponent,
        StripeRegistrationPaymentModalComponent,
        StripeAddTerminalLocationModalComponent,
        StripeAddTerminalReaderModalComponent,
        StripeRefundModalComponent,
        StripeTerminalLocationsComponent,
        AutocompleteComponent,
        AddCourseModalComponent,
        CourseSelectCreateComponent,
        MyAccountPaymentMethodsComponent,
        SchedulerSkeletonComponent,
        PaymentSuccessFailureComponent
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        GtTableComponent,
        FilterNotInPipe,
        SortByPipe,
        YesNoPipe,
        TruncatePipe,
        GroupByPipe,
        MinutesToHoursPipe,
        IsCheckedInComponent,
        TrueFalseComponent,
        EditRegistrationModalComponent,
        AlertModalComponent,
        MessageModalComponent,
        YesNoComponent,
        GoogleSsoComponent,
        OutingOutingIterationSelectComponent,
        TwilioVerificationModalComponent,
        StripePaymentModalComponent,
        StripePaymentElementComponent,
        StripeCardComponent,
        StripeConnectExpressCreateModalComponent,
        MyAccountSkeletonComponent,
        MyAccountSubscriptionsSkeletonComponent,
        DashboardOrganizerSkeletonComponent,
        PostLoginLayoutSkeletonComponent,
        StripeRegistrationPaymentModalComponent,
        StripeAddTerminalLocationModalComponent,
        StripeAddTerminalReaderModalComponent,
        StripeRefundModalComponent,
        StripeTerminalLocationsComponent,
        AutocompleteComponent,
        AddCourseModalComponent,
        CourseSelectCreateComponent,
        MyAccountPaymentMethodsComponent,
        PrimeNgModule,
        SyncfusionModule,
        SchedulerSkeletonComponent,
        PaymentSuccessFailureComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        StripeElementsDirective,
        StripePaymentElementComponent,
        StripeCardComponent,
        NgxSkeletonLoaderModule,
        NgxStripeModule.forRoot(environment.stripe.token),
        PrimeNgModule,
        SyncfusionModule
    ],
    providers: [
        RoleGuardService,
        GtStripeService,
        SignalrService
    ]
})
export class SharedModule { }
